'use es6';

import Client from 'AdsUI/data/Client';
const adAccountUrl = 'ads/v1/ad-account';
export default {
  fetchOverview() {
    return Client.apiRequest(`${adAccountUrl}/user-overview`);
  },

  fetchPermissions() {
    return Client.apiRequest(`${adAccountUrl}/my-permissions`);
  },

  fetchAllPermissions() {
    return Client.apiRequest(`${adAccountUrl}/all-permissions`);
  },

  fetchAdProfile() {
    return Client.apiRequest(`${adAccountUrl}/portal-metadata`);
  }

};